const sliders = async function () {
    const flexCarousels = document.querySelectorAll('.text-slider-carousel') !== null;
    const homeHeroCarousels = document.querySelectorAll('.hero-home-carousel') !== null;
    const tilesCarousels = document.querySelectorAll('.tiles-carousel') !== null;
    const testimonialsCarousels = [...document.querySelectorAll('.testimonial-carousel')];



    if (flexCarousels || homeHeroCarousels || tilesCarousels || testimonialsCarousels) {
        let SwiperLib = await import('swiper/bundle');
        let Swiper = SwiperLib.default;

        if (flexCarousels) {
            const flexTextSwiper = new Swiper('.text-slider-carousel', {
                lazy: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 5000,
                },
                speed: 1500,
                slidersPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        }

        if (homeHeroCarousels) {
            const homeHeroSwiper = new Swiper('.hero-home-carousel', {
                lazy: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 5000,
                },
                speed: 1500,
                slidersPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        }
        if (tilesCarousels) {
            const tilesCarousel = new Swiper('.tiles-carousel', {
                lazy: true,
                // loop: true,
                autoplay: {
                    delay: 5000,
                },
                spaceBetween: 8,
                speed: 1500,
                slidesPerView: 2.1,
                breakpoints: {
                    // when window width is >= 320px
                    768: {
                        slidesPerView: 2.3,
                    },
                    1024: {
                        slidesPerView: 3.2,
                    },
                    1280 : {
                        slidesPerView : 4
                    }
                },
            });
        }
        if (testimonialsCarousels) {

            testimonialsCarousels.forEach(section => {
                const carousel = new Swiper(section.querySelector('.swiper'), {
                    lazy: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    spaceBetween: 8,
                    speed: 1500,
                    slidesPerView: 1,
                    breakpoints: {
                        // when window width is >= 320px
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    },
                    pagination: {
                        el: section.querySelector('.swiper-pagination'),
                        type: 'bullets',
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-carousel-next-el"),
                        prevEl: section.querySelector(".swiper-carousel-prev-el"),
                    },
                });
                
            })
        }
    }
}

export const init = sliders;